import { environment } from '@environments/environment';

export const GET_STORE_TEAMS_QUERY = (langcode: string, storeUuid: string) => ({
  query: '_search',
  index: environment.integrations?.fournierWebservice?.index_teams ?? '',
  body: {
    size: 100,
    query: {
      bool: {
        filter: [
          {
            term: {
              store_uuid: storeUuid,
            },
          },
          {
            term: {
              search_api_language: langcode,
            },
          },
        ],
      },
    },
    sort: [
      {
        weight: {
          order: 'asc',
        },
      },
    ],
    _source: ['name', 'position', 'image'],
  },
});
